/*
    @author: Raghavendra Chaturvedula
    @service: Session timeout service
    @published: 26-12-2019
    @description: To use start/stop/restart session timer including multi tab tracking of the application
    @version: 0.1
	@modified by: n/a
*/

import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription, timer  } from 'rxjs';

@Injectable()
export class SessionTimeoutService {

    private _count = 0;
    private _serviceId = 'idleTimeoutSrv-' + Math.floor(Math.random() * 10000);
    private _baseTimerCouter: number = (60 * 13); // 13 mins
    public _timeoutSeconds: number = this._baseTimerCouter;
    private _timerSubs: Subscription;
    private _timer: Observable<number>;
    private timer: Observable<number>;
    private _resetOnTrigger = false;
    public timeoutExpried: Subject<number> = new Subject<number>();

    constructor() {}

    /*
     * unsubscribe the existing timer
     * restart session timer
     * once timer is completed call timerComplet method
     */
    private _restartCounter() {

        if (this._timerSubs) {
            this._timerSubs.unsubscribe();
        }

        // //console.log('from srv on resetcounter = ',this._timeoutSeconds);
        this._timer = timer(this._timeoutSeconds * 1000);

        this._timerSubs = this._timer.subscribe(num => {
            this.timerComplete(num);
        });
    }
    /*
     * Start the session timer
     */
    public startTimer() { //console.log('enter this loop')

        this._timeoutSeconds = this._baseTimerCouter;
        this.setLocalSession('true');

        if (this._timerSubs) {
            this._timerSubs.unsubscribe();
        }

        // //console.log('srv on start = ',this._timeoutSeconds);
        this._timer = timer(this._timeoutSeconds * 1000);

        this._timerSubs = this._timer.subscribe(num => {
            this.timerComplete(num);
        });
    }
    /*
     * Restart the session timer
     */
    public resetTimer() {

        this._timeoutSeconds = this._baseTimerCouter;
        this.setLocalSession('true');

        if (this._timerSubs) {
            this._timerSubs.unsubscribe();
        }

        // //console.log('src on reset = ',this._timeoutSeconds);
        this._timer = timer(this._timeoutSeconds * 1000);

        this._timerSubs = this._timer.subscribe(num => {
            this.timerComplete(num);
        });
    }
    /*
     * Stop the session timer/unsubscribe
     */
    public stopTimer() {
        this._timerSubs.unsubscribe();
    }
    /*
     * Once timer completed increase the session extending counter
     */
    private timerComplete(num: number) {

        this.timeoutExpried.next(++this._count);
    }
    /*
     * After selection of Cancel button start timer for last 1 min counter
     */
    public addonTime() {

        this._timeoutSeconds = (60 * 2); // 2 min hold
        this.setLocalSession('false');

        if (this._timerSubs) {
            this._timerSubs.unsubscribe();
        }

        // //console.log('addon timer = ',this._timeoutSeconds);
        this._timer = timer(this._timeoutSeconds * 1000);

        this._timerSubs = this._timer.subscribe(num => {
            this.timerComplete(num);
        });
        // //console.log('add 1 min more and trigger backend call', this._timeoutSeconds);
    }
    /*
     * For multi tab tracking set session variable
     */
    public setLocalSession(val: string): void {
        localStorage.setItem('isLocalSessionActive', String(val));
    }
    /*
     * For multi tab tracking get session variable state
     */
    public getLocalSession(): string {
        return localStorage.getItem('isLocalSessionActive');
    }


}
